import React from 'react';
import { Input, Button } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { Logo } from 'assets/img';
import { AuthService } from 'services';
import moment from 'moment';
import { connect } from 'react-redux';

interface Props extends RootState {
	onClose?: any;
	dispatch?: any;
}

const RESPONSES = {
	SUCCESS: 1,
	DENIED: 2
}

class ModalVerifyAccount extends React.Component<Props> {

	state = {
		form: {
			code: '',
			phone: ''
		},
		response: null,
		interval: null,
		active_resend: this.props.code_send_at == null || moment().subtract(30,'seconds').format('YYYY-MM-DD HH:mm:ss') > this.props.code_send_at,
		seconds: moment(this.props.code_send_at).diff(moment().subtract(30,'seconds'),'seconds')
	}

	componentDidMount() {
		this.check();

		this.setState({
			interval: setInterval(() => {
				this.setState({
					active_resend: this.props.code_send_at == null || moment().subtract(30,'seconds').format('YYYY-MM-DD HH:mm:ss') > this.props.code_send_at,
					seconds: moment(this.props.code_send_at).diff(moment().subtract(30,'seconds'),'seconds')
				});
			},1000)
		});
	}

	componentWillUnmount() {
		// @ts-ignore
		clearInterval(this.state.interval);
	}

	check = async () => {
		const res: any = await AuthService.checkUser({
          user_id: this.props.user?.id,
          withoutLoading: true
        });
        if (res.user) {
			this.setState({
				form: {
					...this.state.form,
					phone: res.user?.phone || ''
				}
			});
        }
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	submit = async (e: any) => {
		e.preventDefault();
		this.props.onClose();
	}

	getResponse = (response: number) => {
		switch(response) {
			// @ts-ignore
			case RESPONSES.SUCCESS: 
				return 'Cuenta verificada presiona finalizar para continuar';
			break;

			default:
				return 'No se pudo validar tu cuenta, verifica tu teléfono y vuelve a intentarlo';
			break;
		}
	}

	validate = async (e: any) => {
		e.preventDefault();
		if (!this.state.form.code) {
			Globals.showError("Por favor, ingrese el código de verificación");
			return;
		}
		const res: any = await AuthService.validate({
			user_id: this.props.user?.id,
			code: this.state.form.code
		});
		this.setState({
			response: res.response
		},() => {
			if (res.user) {
				this.props.dispatch({
					type: 'SET_USER',
					payload: res.user
				});
			}
		});
	}

	resend = async (e: any, by_email = false) => {
		e.preventDefault();
		if (this.state.response != RESPONSES.SUCCESS && this.state.active_resend) {
			await AuthService.resendCode({
				user_id: this.props.user?.id,
				phone: this.state.form.phone,
				by_email
			});
			Globals.showSuccess(`Se ha reenviado el código a su ${ by_email ? 'correo electrónico' : 'teléfono' }`);
			this.props.dispatch({
				type: 'SET_CODE_SEND',
				payload: moment().format('YYYY-MM-DD HH:mm:ss')
			});
		}
	}

	logout = () => {
		this.props.dispatch({
			type: 'SET_USER',
			payload: null
		});
		this.props.onClose(true);
	}

	render() {
		return (
			<div id="modal-quotes-verify-account">
				<div className="text-center">
					<img src={ Logo } className="logo" />
				</div>
				<h3>Finalizar registro</h3>
				<p className="subtitle-validate">Tu registro esta casi listo, introduce el código de confirmación que envíamos a tu número de teléfono para continuar.</p>
				{
					this.state.response != RESPONSES.SUCCESS && (
						<form className="row" onSubmit={ this.validate }>
							<div className="col-md-6">
								<Input
									type="number"
									color="white"
									value={ this.state.form.phone }
									name="phone" 
									placeholder="Teléfono"
									onChange={ this.change } />
							</div>
							<div className="col-md-6">
								<Input
									type="number"
									maxLength={ 6 }
									color="white"
									value={ this.state.form.code }
									name="code" 
									placeholder="Introduce el código aquí"
									onChange={ this.change } />
							</div>
							<div className="text-center col-md-12">
								<Button type="submit" className="button-validate">
									Validar
								</Button>
							</div>
						</form>
					)
				}
				{
					this.state.response != RESPONSES.SUCCESS && (
						<>
							<div className="text-center">
								<a href="#" className={ `resend-code ${ !this.state.active_resend ? 'disabled' : '' }` } onClick={ (e: any) => this.resend(e) }>Reenviar código</a>
							</div>
							<div className="text-center">
								<a href="#" className={ `resend-code blue ${ !this.state.active_resend ? 'disabled' : '' }` } onClick={ (e: any) => this.resend(e,true) }>¿Tiene problemas para recibir el código? Enviarlo al correo</a>
							</div>
							{
								!this.state.active_resend && (
									<p className="message-resend">Por favor, espere { this.state.seconds } segundos para reenviar el código</p>
								)
							}

							<div className="logout" onClick={ () => this.logout() }>
								Iniciar sesión con otro usuario
							</div>
						</>
					) 
				}
				{
					this.state.response != null && (
						<p className={ `response top ${ this.state.response == RESPONSES.SUCCESS ? 'response-blue' : 'response-red' }` }> {
							// @ts-ignore 
							this.getResponse(this.state.response)
						}</p>
					)
				}
				{
					this.state.response == RESPONSES.SUCCESS && (
						<div className="text-center container-input container-btn-submit">
							<Button type="button" onClick={ this.submit }>
								Finalizar
							</Button>
						</div>
					)
				}
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		code_send_at: state.code_send_at,
		user: state.user
	}
})(ModalVerifyAccount);